import * as React from 'react';
import { BasePureComponent } from '../BaseComponent';
import * as Data from '../../Data';
import * as Dati from '../../Dati';
import * as Glob from '../../Globale';
import { AddendumDataIndirizzi, AddendumDataMultiInfo, AddendumDataRubrica, CampoMultiSelezione, ChiamaAPI, Trad } from '../../components/';

interface IAddendumListItemProps {
    Data: Dati.CAppendiceTestata;
}

export class AddendumListItem extends BasePureComponent<IAddendumListItemProps> {
    public constructor(props: any) {
        super(props);

        this.OnResAddendumDetails = this.OnResAddendumDetails.bind(this);
    }

    private RenderFormField(field: any): React.ReactNode {
        let fieldNode: any = null;
        switch (field.ID_TipoCampo) {
            case 3: //Date
                fieldNode = <input className="form-control kt-input" type="text" value={field.ValoreAppendice && Data.DataValoreStringa(field.ValoreAppendice)} name={field.CampoAppendice} readOnly />;
                break;
            case 5: //Checkbox
                fieldNode = (
                    <div className="col-lg-12">
                        <label className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">
                            {Trad.Trad(field.Etichetta)}
                            <input name={field.CampoAppendice} id={field.CampoAppendice} type="checkbox" checked={!!field.ValoreAppendice} readOnly />
                            <span />
                        </label>
                    </div>
                );
                break;
            case 12: //MultiSelezione
                fieldNode = (
                    <CampoMultiSelezione
                        Valori={field.ValoreAppendice}
                        Id={field.CampoAppendice}
                        Name={field.CampoAppendice}
                        Grafica="CheckBox"
                        OnChange={() =>{}}
                        BloccoAltezza={false}
                    />
                );
                break;
            default:
                fieldNode = <input className="form-control kt-input" type="text" value={field.ValoreAppendice} name={field.CampoAppendice} readOnly />;
                break;
        }
        return (
            <React.Fragment>
                {field.Etichetta && !(field.ID_TipoCampo == 5) && <label className="form-control-label">{Trad.Trad(field.Etichetta)}</label>}
                {fieldNode}
            </React.Fragment>
        )
    }

    private OnResAddendumDetails(sender: ChiamaAPI, data: Dati.CRisAPIDato<Dati.CAppendice>, newData: boolean): React.ReactNode {
        if (!data.Errore && data.Dato && data.Dato.Dati && data.Dato.Dati.length) {
            const id = data.Dato.Testata.ID_Appendice;

            return(
                <React.Fragment>
                    <h5 className="kt-portlet__head-label">
                        <a data-toggle="collapse" href={`#addendumData${id}`} aria-expanded="true" className="arrow">
                            <i className="fa fa-search" />
                        </a>
                    </h5>
                    <div className="collapse in" id={`addendumData${id}`}>
                        {data.Dato.Dati.map(item => (
                            <div className="form-group kt-form login-form__group row" key={item.Etichetta}>
                                <div className="col-lg-12">
                                    {item.ID_TipoCampo == 0 && item.Etichetta == 'RecapitiJSON' &&
                                        <AddendumDataRubrica Data={item.ValoreAppendice} RenderFormField={this.RenderFormField} />
                                    }
                                    {item.ID_TipoCampo == 0 && item.Etichetta == 'IndirizziJSON' &&
                                        <AddendumDataIndirizzi Data={item.ValoreAppendice} RenderFormField={this.RenderFormField} />
                                    }
                                    {item.ID_TipoCampo === 0 && item.Etichetta.includes('RCPG-Accessoria') &&
                                        this.RenderFormField({
                                            CampoAppendice: item.CampoAppendice,
                                            Etichetta: item.Etichetta,
                                            ID_TipoCampo: 5,
                                            ValoreAppendice: item.ValoreAppendice && JSON.parse(item.ValoreAppendice)
                                        })
                                    }
                                    {item.ID_TipoCampo === 13 && <AddendumDataMultiInfo Data={item} RenderFormField={this.RenderFormField} />}
                                    {item.ID_TipoCampo !== 0 && item.ID_TipoCampo !== 13 && this.RenderFormField(item)}
                                </div>
                            </div>
                        ))}
                    </div>
                </React.Fragment>
            )
        }
        return false;
    }

    public render() {
        const data = this.props.Data;
        const id = data.ID_Appendice; 
        return (
            <tr>
                <td data-field="ID_Appendice" className="TextCenter">{id}</td>
                <td data-field="ID_TipoAppendice" className="TextLeft">{data.ID_TipoAppendice && Trad.Trad(data.ID_TipoAppendice)}</td>
                <td data-field="ID_TipoAppendiceStato" className="TextLeft">{Trad.Trad(data.ID_TipoAppendiceStato)}</td>
                <td data-field="NumeroAppendice" className="TextCenter">{data.NumeroAppendice}</td>
                <td data-field="PolizzaAppendice" className="TextLeft">{data.PolizzaAppendice}</td>
                <td data-field="ID_Polizza" className="TextLeft">{data.ID_Polizza}</td>
                <td data-field="Polizza" className="TextLeft">{data.Polizza}</td>
                <td data-field="DataEffetto" className="TextCenter">{data.DataEffetto.toLocaleDateString()}</td>
                <td data-field="DataScadenza" className="TextCenter">{data.DataScadenza.toLocaleDateString()}</td>
                <td data-field="Dati" className="TextCenter">
                    <ChiamaAPI
                        Aggiornare={1}
                        URL={`/api/Appendice?id_appendice=${id}`}
                        OnRis={this.OnResAddendumDetails}
                        OnErrore={this.OnErrore}
                    />
                </td>
                <td data-field="Operazione" className="TextCenter">
                    {data.ID_TipoAppendiceStato === Glob.Tipi_APS_Preventivo
                        ? <div className="divtabella">
                            <button type="button" data-toggle="modal" data-target={`#kt_modal_${id}`} className="btn btn-metal kt-btn kt-btn--icon btn--icon-only"  title={Trad.Trad("Modifica")}>
                                <i className="fa fa-hand-pointer" />
                            </button>
                        </div>
                        : <div className="divtabella"><i className="fa fa-check" /></div>
                    }
                </td>
                <td data-field="Nota" className="TextCenter">{data.Nota}</td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AddendumList/AddendumListItem.tsx